import * as React from "react";
import PropTypes from "prop-types";
import SCComboBoxGeo from "../ComboBoxes/SCComboBoxGeo";
import SCComboBoxPEPFARCategories from "../ComboBoxes/SCComboBoxPEPFARCategories";
import SCComboBoxVMMCCategories from "../ComboBoxes/SCComboBoxVMMCCategories";
import SCComboBoxDREAMS from "../ComboBoxes/SCComboBoxDREAMS";
import SCComboBoxUSGAgencies from "../ComboBoxes/SCComboBoxUSGAgencies";
import SCComboBoxImplementingPartners from "../ComboBoxes/SCComboBoxImplementingPartners";
import SCComboBoxServiceDeliveryModes from "../ComboBoxes/SCComboBoxServiceDeliveryModes";
import SCComboBoxOwnership from "../ComboBoxes/SCComboBoxOwnership";
import SCComboBoxMove from "../ComboBoxes/SCComboBoxMove";
import SCComboBoxTaskShifting from "../ComboBoxes/SCComboBoxTaskShifting";
import * as SCConst from "../NonComponents/SCConst.js";
import { getCategoryName } from "../NonComponents/SCDataUtil.js";

class SCCharacteristicComboBoxes extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        catInfo: PropTypes.object,
        indInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        siteCharByTimeInfo: PropTypes.object,

        GeoItemIndex: PropTypes.number,
        PEPFARCategoriesItemIndex: PropTypes.number,
        VMMCCategoriesItemIndex: PropTypes.number,
        DREAMSItemIndex: PropTypes.number,
        USGAgenciesItemIndex: PropTypes.number,
        ImplementingPartnersItemIndex: PropTypes.number,
        ServiceDeliveryModesItemIndex: PropTypes.number,
        OwnershipItemIndex: PropTypes.number,
        MoveIdx: PropTypes.number,
        TaskShiftingIdx: PropTypes.number,

        onGeoChange: PropTypes.func,
        onPEPFARCategoriesChange: PropTypes.func,
        onVMMCCategoriesChange: PropTypes.func,
        onDREAMSChange: PropTypes.func,
        onUSGAgencieChange: PropTypes.func,
        onImplementingPartnersChange: PropTypes.func,
        onServiceDeliveryModesChange: PropTypes.func,
        onOwnershipChange: PropTypes.func,
        onMoveChange: PropTypes.func,
        onTaskShiftingChange: PropTypes.func,
    };

    static defaultProps = {
        catInfo: null,
        indInfo: null,
        mstIDsObj: null,
        siteCharByTimeInfo: null,

        GeoItemIndex: 0,
        PEPFARCategoriesItemIndex: 0,
        VMMCCategoriesItemIndex: 0,
        DREAMSItemIndex: 0,
        USGAgenciesItemIndex: 0,
        ImplementingPartnersItemIndex: 0,
        ServiceDeliveryModesItemIndex: 0,
        OwnershipItemIndex: 0,
        MoveIdx: 0,
        TaskShiftingIdx: 0,

        onGeoChange: () => console.log("onGeoChange"),
        onPEPFARCategoriesChange: () => console.log("onPEPFARCategoriesChange"),
        onVMMCCategoriesChange: () => console.log("onVMMCCategoriesChange"),
        onDREAMSChange: () => console.log("onDREAMSChange"),
        onUSGAgencieChange: () => console.log("onUSGAgencieChange"),
        onImplementingPartnersChange: () => console.log("onImplementingPartnersChange"),
        onServiceDeliveryModesChange: () => console.log("onServiceDeliveryModesChange"),
        onOwnershipChange: () => console.log("onOwnershipChange"),
        onMoveChange: () => console.log("onMoveChange"),
        onTaskShiftingChange: () => console.log("onTaskShiftingChange"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        try {
            let styles = {
                innerPage: {
                    margin: 20,
                },
            };

            const catName = getCategoryName(SCConst.cat_CharMstID, this.props.catInfo, this.props.mstIDsObj);

            return (
                <div style={styles.innerPage}>
                    <h5>{catName}</h5>

                    <SCComboBoxGeo
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.GeoItemIndex}
                        onChange={this.props.onGeoChange}
                    />
                    <SCComboBoxServiceDeliveryModes
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.ServiceDeliveryModesItemIndex}
                        onChange={this.props.onServiceDeliveryModesChange}
                    />
                    <SCComboBoxPEPFARCategories
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.PEPFARCategoriesItemIndex}
                        onChange={this.props.onPEPFARCategoriesChange}
                    />
                    <SCComboBoxVMMCCategories
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.VMMCCategoriesItemIndex}
                        onChange={this.props.onVMMCCategoriesChange}
                    />
                    <SCComboBoxDREAMS
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.DREAMSItemIndex}
                        onChange={this.props.onDREAMSChange}
                    />
                    <SCComboBoxUSGAgencies
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.USGAgenciesItemIndex}
                        onChange={this.props.onUSGAgencieChange}
                    />
                    <SCComboBoxImplementingPartners
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.ImplementingPartnersItemIndex}
                        onChange={this.props.onImplementingPartnersChange}
                    />
                    <SCComboBoxOwnership
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.OwnershipItemIndex}
                        onChange={this.props.onOwnershipChange}
                    />
                    <SCComboBoxMove
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.MoveIdx}
                        onChange={this.props.onMoveChange}
                    />
                    <SCComboBoxTaskShifting
                        indInfo={this.props.indInfo}
                        siteCharByTimeInfo={this.props.siteCharByTimeInfo}
                        mstIDsObj={this.props.mstIDsObj}
                        itemIndex={this.props.TaskShiftingIdx}
                        onChange={this.props.onTaskShiftingChange}
                    />
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCCharacteristicComboBoxesDiv"}
                    key={"SCCharacteristicComboBoxesDiv"}
                >
                    <h3 key={"SCCharacteristicComboBoxesDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCCharacteristicComboBoxes;
